declare global {
  interface Window {
    posthog?: {
      capture: (event: string, props?: Record<string, unknown>) => void
      captureException?: (error: unknown, props?: Record<string, unknown>) => void
      get_distinct_id?: () => string
      get_session_id?: () => string
      get_property?: (key: string) => unknown
      register_once?: (props: Record<string, unknown>) => void
      setPersonProperties?: (props: Record<string, unknown>) => void
    }
  }
}

export function posthogDistinctId(): string | undefined {
  return window.posthog?.get_distinct_id?.()
}

export function posthogSessionId(): string | undefined {
  return window.posthog?.get_session_id?.()
}

/** Headers so Rails events stitch to the same PostHog person + session. */
export function analyticsHeaders(): Record<string, string> {
  const headers: Record<string, string> = {}
  const distinctId = posthogDistinctId()
  const sessionId = posthogSessionId()
  if (distinctId) headers["X-POSTHOG-DISTINCT-ID"] = distinctId
  if (sessionId) headers["X-POSTHOG-SESSION-ID"] = sessionId
  return headers
}

export function captureEvent(event: string, properties: Record<string, unknown> = {}): void {
  window.posthog?.capture(event, {
    page_path: window.location.pathname,
    ...properties,
  })
}

export function captureException(error: unknown, properties: Record<string, unknown> = {}): void {
  window.posthog?.captureException?.(error, properties)
}
